import { MealPlanDetail } from "@corpuscomplete/core-ui/nutrition/meal-plan/detail";
import { MealPlanPage } from "@corpuscomplete/web/modules/nutrition/meal-plan/pages/meal-plan-detail";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/personal/meal-plans/$id")({
  component: () => {
    const { id } = Route.useParams();
    return <MealPlanPage id={id} />;
  },
  loader: async ({ context, params }) => {
    if (context.zero) {
      MealPlanDetail.preload(context.zero, params.id);
    }
  },
});
